class ProductSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', this.onChange.bind(this));
    });

    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    if (!this.variants) {
      console.error('No variants found');
      return;
    }

    this.productCard = this.closest('[data-product-card]');
    this.productCardImageContainer = this.productCard.querySelector('[data-product-card-image-container]');
    this.productCardImage = this.productCardImageContainer.querySelectorAll('img')[0];
    this.productCardLoadingOverlay = this.productCardImageContainer.querySelector('[data-loader]');
    this.productCardLinks = this.productCard.querySelectorAll('a');
    this.productCardForm = this.productCard.querySelector('form');
  }

  disconnectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.removeEventListener('change', this.onChange.bind(this));
    });
  }

  onChange(event) {
    const input = event.target;
    const value = input.value;
    const variant = this.variants.find(variant => variant.option1 === value);
    this.productCardLoadingOverlay?.classList.remove('hidden');

    // update the image
    this.productCardImage.src = variant.featured_image;
    this.productCardImage.srcset = '';

    // update the url
    this.productCardLinks.forEach(link => {
      link.href = variant.url;
      link.title = variant.title;
    });

    //check for availability
    if (variant.available) {
      this.productCard.classList.remove(...['opacity-50', 'saturate-50']);
    }
    else {
      this.productCard.classList.add(...['opacity-50', 'saturate-50']);
    }

    if (this.productCardForm) {
      this.productCardForm.querySelector('input[name="id"]').value = variant.variant_id;
    }

    window.dispatchEvent(
      new CustomEvent('product:swatch-change', {
        bubbles: true,
        detail: {
          variantId: variant.variant_id,
          productFormId: this.productCardForm?.id || null,
        },
      }),
    );

    this.productCardLoadingOverlay.classList.add('hidden');
  }
}
if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches);
}
